import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';
import { ComponentsOfValueComponent } from './components-of-value';
import {NgPipesModule} from 'ngx-pipes';

@NgModule({
  declarations: [
    ComponentsOfValueComponent,
  ],
  imports: [
    IonicModule,
    NgPipesModule,
  ],
  exports: [
    ComponentsOfValueComponent
  ]
})
export class ComponentsOfValueComponentModule {}



// WEBPACK FOOTER //
// ./src/components/components-of-value/components-of-value.module.ts